// Transforms for example {a: true, b: false, c: null, d: true, e: false} to ['a', 'd']
export const booleanObjectToList = (object: { [key: string]: any }) =>
  Object.keys(object).filter((key) => object[key] === true);
